module.exports = __webpack_public_path__ + "img/logo_login.707ba3d1.png";